import { render, staticRenderFns } from "./HomeDataBlock.vue?vue&type=template&id=f7182a7e"
import script from "./HomeDataBlock.vue?vue&type=script&lang=js"
export * from "./HomeDataBlock.vue?vue&type=script&lang=js"
import style0 from "./HomeDataBlock.vue?vue&type=style&index=0&id=f7182a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports